module.exports = __webpack_public_path__ + "img/template_active.44df4034.svg";